import {Dialog} from '@reach/dialog';
import {DialogFooter, DialogTitle} from '@common/components/Dialog';
import {
  Input,
  FormItem,
} from '@common/components/form-items';
import Button, {ButtonGroup} from '@common/components/Button';
import InfoTip from '@gakki/components/info-tip/info-tip';
import { SubjectBlock, SubjectHead, SubjectRow} from './salary-subject-data';

function SystemSubjectDialog(props: any) {
  const {
    isOpen,
    onClose,
    salarySubjects,
  } = props;
  const hourlySalaryCode = '1002';
  const baseSalaryCode = '1000';
  const foodAllowanceCode = '1001';
  const fixedSubjectCode = [hourlySalaryCode, baseSalaryCode, foodAllowanceCode];

  const filterFixedSubjectCode = (subject: any) => !fixedSubjectCode.includes(subject.code)
  const sortBySubjectCode = (a: any, b: any) => a.code[0] - b.code[0]
  const renderRow = (subject: any, index: number) => {
    return (
      <SubjectRow key={`system-subject-${index}`} className="h-[40px]">
        <div style={{width: '80px'}}>{subject.code}</div>
        <div>{subject.name}</div>
      </SubjectRow>
    );
  }
  return (
    <Dialog isOpen={isOpen} style={{width: 350}} aria-label="system-subject-dialog">
      <DialogTitle
        title={"系統預設薪資科目"}
        onClose={onClose}
      />
      <div className={'flex flex-col pt-5'}>
        <SubjectBlock>
          <SubjectHead className="h-[40px]">
            <div style={{width: '80px'}}>科目代碼</div>
            <div>科目名稱</div>
          </SubjectHead>
          <div className={'h-[399px] overflow-auto'}>
            {salarySubjects
            .filter(filterFixedSubjectCode)
            .sort(sortBySubjectCode)
            .map(renderRow)}
          </div>
        </SubjectBlock>
      </div>
    </Dialog>
  );
}

export default SystemSubjectDialog;
